import { createContext } from 'react'

import {
  createApiKey,
  revokeApiKey,
  assignApiKeyPurpose,
  replaceLegacyApiKey,
  rotateApiKey,
} from '../graphql/mutations'

import {
  viewApiKeys,
} from '../graphql/queries'
import { generateClient } from '@aws-amplify/api'

const ApiKeyContext = createContext()
export default ApiKeyContext

const ContextState = () => {

  // Migrating from Amplify V5 to V6.
  // https://docs.amplify.aws/react/migrate-v5-to-v6/migrate-graphql-api/
  const client = generateClient();

  const listKeys = async ({ status }) => {
    const result = await client.graphql({
      query: viewApiKeys,
      authMode: 'userPool',
      variables: {
        input: {
          limit: 100,
          status,
        },
      },
    })
    return result.data.viewApiKeys
  }

  const mutateKey = async (query, input, field) => {
    const result = await client.graphql({
      query,
      authMode: 'userPool',
      variables: { input },
    })
    return result.data[field]
  }

  const createKey = ({ name, purpose }) => mutateKey(createApiKey, { name, purpose }, 'createApiKey')

  const revokeKey = async ({ apiKeyId }) => {
      const result = await client.graphql({
      query: revokeApiKey,
      authMode: 'userPool',
      variables: {
        input: {
          apiKeyId,
        },
      },
    })
    return result.data.revokeApiKey
  }

  return {
    listKeys,
    createKey,
    revokeKey,
    assignPurpose: ({ apiKeyId, purpose }) => mutateKey(assignApiKeyPurpose, { apiKeyId, purpose }, 'assignApiKeyPurpose'),
    rotateKey: ({ apiKeyId }) => mutateKey(rotateApiKey, { apiKeyId }, 'rotateApiKey'),
    replaceLegacyKey: ({ name, purpose }) => mutateKey(replaceLegacyApiKey, { name, purpose }, 'replaceLegacyApiKey'),
  }
}

const ApiKeyContextProvider = (props) => {
  const state = ContextState()

  return (
    <ApiKeyContext.Provider value={state}>
      {props.children}
    </ApiKeyContext.Provider>
  ) 
}

export { ApiKeyContext, ApiKeyContextProvider }
